module.exports = __webpack_public_path__ + "static/media/taxi.259641c2.svg";